
import commonStore from '@/store/common';
import softConfigtore, { SoftConfig } from '@/store/common/system';
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import { ConfigProvider } from 'ant-design-vue';
import axios from '@/axios/fetch';
import useConfigHooks from './hooks/config.hooks';
import config from '../package.json';

export default {
  components: {
    AConfigProvider: ConfigProvider,
  },
  setup() {
    console.log('前端版本：', config.version);
    const locale = zhCN;
    const configHooks = useConfigHooks();

    window.onbeforeunload = (): void => {
      // sessionStorage.setItem('heroUserStore', JSON.stringify(commonStore.getState()));
      // sessionStorage.setItem('heroSoftConfig', );
      configHooks.softConfig.set(softConfigtore.getState());
    };

    const heroUserStore = sessionStorage.getItem('heroUserStore');
    // const heroSoftConfig = sessionStorage.getItem('heroSoftConfig');
    const heroSoftConfig = configHooks.softConfig.get();
    console.log(heroUserStore, heroSoftConfig);
    if (heroUserStore) {
      commonStore.updateUserInfo(JSON.parse(heroUserStore));
      // sessionStorage.removeItem('heroUserStore');
    }
    // if (heroSoftConfig) {
    //   softConfigtore.updateSoftConfig(JSON.parse(heroSoftConfig));
    //   sessionStorage.removeItem('heroSoftConfig');
    // } else {
    axios.get('./softConfig/get').then((res) => {
      softConfigtore.updateSoftConfig(res.data as SoftConfig);
    });
    // }

    axios.get('./version/get').then((res) => {
      const { version } = res.data;
      const num = version.indexOf('(');
      if (num >= 0) {
        softConfigtore.updateVersion(version.slice(0, num));
      } else {
        softConfigtore.updateVersion(version);
      }
    });

    return { locale };
  },

};

